<span class="title black">Confirmar acción</span>
<p class="question" [innerHTML]="data?.question | safeHtml"></p>
<p class="warning" [innerHTML]="data?.warning | safeHtml"></p>

<div style="margin-top: 24px;" class="modal-actions">
    <span class="modal-button pointer gray" (click)="cancel()">Cancelar</span>
    <span class="modal-button pointer blue" style="margin-left: 48px;" (click)="confirm()">Confirmar</span>
</div>